import { createApi } from "@reduxjs/toolkit/query/react";

import { axiosBaseQuery } from "./services/axiosBaseQuery";
import { publicApiClient } from "./services/publicApiClient";

/**
 * The single UNAUTHENTICATED RTK Query API (PLX §6) — drives requests through
 * `publicApiClient`, which never attaches a bearer token. Anonymous endpoints
 * (if migrated off `baseApi`) inject here via `injectEndpoints`.
 */
export const publicApi = createApi({
  reducerPath: "publicApi",
  baseQuery: axiosBaseQuery({ client: publicApiClient }),
  endpoints: () => ({}),
});
